class UgcTikTokVideos {
  constructor(section) {
    this.section = section;
    this.viewport = section.querySelector('[data-ugc-viewport]');
    this.cards = [...section.querySelectorAll('.ugc-tiktok__card')];
    this.players = [...section.querySelectorAll('[data-ugc-player]')];
    this.prev = section.querySelector('[data-ugc-prev]');
    this.next = section.querySelector('[data-ugc-next]');
    this.autoplay = section.dataset.autoplay === 'true';

    this.bind();
    this.startAllPlayers();
    this.updateArrows();
  }

  bind() {
    this.prev?.addEventListener('click', () => this.scroll(-1));
    this.next?.addEventListener('click', () => this.scroll(1));

    this.viewport?.addEventListener(
      'scroll',
      () => this.updateArrows(),
      { passive: true }
    );
  }

  scroll(direction) {
    const card = this.cards[0];

    if (!card || !this.viewport) return;

    const gap =
      parseFloat(
        getComputedStyle(this.section)
          .getPropertyValue('--ugc-gap')
      ) || 16;

    this.viewport.scrollBy({
      left: direction * (
        card.getBoundingClientRect().width + gap
      ),
      behavior: 'smooth'
    });
  }

  updateArrows() {
    if (!this.viewport) return;

    const max =
      this.viewport.scrollWidth -
      this.viewport.clientWidth -
      2;

    if (this.prev) {
      this.prev.disabled =
        this.viewport.scrollLeft <= 2;
    }

    if (this.next) {
      this.next.disabled =
        this.viewport.scrollLeft >= max;
    }
  }

  post(player, command) {
    try {
      player.contentWindow?.postMessage(
        {
          type: command,
          'x-tiktok-player': true
        },
        'https://www.tiktok.com'
      );
    } catch (e) {}
  }

  startAllPlayers() {
    if (!this.autoplay) return;

    this.players.forEach((player) => {
      const start = () => {
        this.post(player, 'play');

        setTimeout(() => {
          this.post(player, 'play');
        }, 500);

        setTimeout(() => {
          this.post(player, 'play');
        }, 1500);
      };

      player.addEventListener(
        'load',
        start,
        { once: true }
      );

      start();
    });
  }
}

function initUgcTikTokVideos(root = document) {
  root
    .querySelectorAll('[data-ugc-tiktok]')
    .forEach((section) => {
      if (section.dataset.ugcInitialized === 'true') {
        return;
      }

      section.dataset.ugcInitialized = 'true';

      new UgcTikTokVideos(section);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    initUgcTikTokVideos();
  }
);

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initUgcTikTokVideos(event.target);
  }
);